import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${({ theme, baseBackground }) =>
    baseBackground(theme) || 'transparent'};
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: ${({ allowOverflow }) => (allowOverflow ? 'visible' : 'hidden')};

  ${({ mixBlendMode }) => mixBlendMode && `mix-blend-mode: ${mixBlendMode}`};
`;

const Foreground = styled.div`
  isolation: isolate;
`;

export function BackgroundBase({
  allowOverflow,
  children,
  baseBackground,
  renderBackground,
  mixBlendMode,
  variant,
}) {
  return (
    <Wrapper>
      <Background
        allowOverflow={allowOverflow}
        baseBackground={baseBackground}
        mixBlendMode={mixBlendMode}
      >
        {renderBackground(variant)}
      </Background>
      <Foreground>{children}</Foreground>
    </Wrapper>
  );
}
